import Home from '../Home/Home';

export default Home;
